// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1698) return "static/chunks/1698-a37c6dd66ffdc994.js";
	if (chunkId === 4075) return "static/chunks/4075-621c51f94b9f5521.js";
	if (chunkId === 4015) return "static/chunks/4015-9f87f6b7eee50a24.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"321":"16f9ed105a833c22","3817":"fba579c3bb74df75","6621":"3a72faa4dc0d0483"}[chunkId] + ".js";
};